import { render, staticRenderFns } from "./header-component.vue?vue&type=template&id=676b2bd2&"
import script from "./header-component.vue?vue&type=script&lang=js&"
export * from "./header-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports